import { CommonModule } from '@angular/common'
import { Injectable, ModuleWithProviders, NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core'
import { AppBasicService } from '@data/service/app-basic.service'
import { AppBasicEntity } from '@entity/app-basic.entity'
import { AppBasicLayout } from '@layout/app-basic.layout'
import { TranslateModule } from '@ngx-translate/core'
import { AppBasicPage } from '@page/app-basic.page'
import { SimpleNotificationsModule } from 'angular2-notifications'
import { InlineSVGModule } from 'ng-inline-svg'
import { AuthService } from './auth.service'
import { CodeService } from './code.service'
import { CoreBasicService } from './core-basic.service'
import { CoreService } from './core.service'
import { MaterialModule } from './material.module'
import { NotifyService } from './notify.service'
import { SpinnerPNOComponent, SpinnerB4RComponent, SpinnerSHYPSComponent, SpinnerBINSComponent } from './spinner.component'
import { StageService } from './stage.service'
import { StoreService } from './store.service'
import { TimeService } from './time.service'
import { UserService } from './user.service'

export const CUSTOM_DATE_FORMATS = {
   parse: {
      dateInput: 'DD/MM/YYYY',
   },
   display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MM YYYY',
      dateA11yLabel: 'DD/MM/YYYY',
      monthYearA11yLabel: 'MM YYYY',
   },
}

@Injectable()
export class CustomDateAdapter extends MomentDateAdapter {
   getFirstDayOfWeek(): number {
      return 1
   }
}

@NgModule({
   declarations: [SpinnerPNOComponent, SpinnerB4RComponent, SpinnerSHYPSComponent, SpinnerBINSComponent, AppBasicLayout, AppBasicPage, AppBasicEntity],
   imports: [
      CommonModule,
      MaterialModule,
      FlexLayoutModule,
      FormsModule,
      ReactiveFormsModule,
      SimpleNotificationsModule.forRoot({
         timeOut: 5000,
         showProgressBar: true,
         pauseOnHover: true,
         clickToClose: true,
         position: ['bottom', 'right'],
         lastOnBottom: true,
         maxStack: 3,
         maxLength: 500,
         theClass: 'app-notify',
         icons: {
            success: '<mat-icon class="mat-icon material-icons">check_outline</mat-icon>',
            alert: '<mat-icon class="mat-icon material-icons">notification_important</mat-icon>',
            error: '<mat-icon class="mat-icon material-icons">error_outline</mat-icon>',
            info: '<mat-icon class="mat-icon material-icons">info</mat-icon>',
            warn: '<mat-icon class="mat-icon material-icons">warning</mat-icon>',
         },
      }),
      TranslateModule,
      InlineSVGModule.forRoot(),
   ],
   exports: [
      MaterialModule,
      FlexLayoutModule,
      FormsModule,
      ReactiveFormsModule,
      SimpleNotificationsModule,
      TranslateModule,
      InlineSVGModule,
      SpinnerPNOComponent,
      SpinnerB4RComponent,
      SpinnerSHYPSComponent,
      SpinnerBINSComponent,
   ],
   entryComponents: [SpinnerPNOComponent, SpinnerB4RComponent, SpinnerSHYPSComponent, SpinnerBINSComponent, MaterialModule],
   providers: [
      CoreBasicService,
      CoreService,
      UserService,
      StoreService,
      NotifyService,
      { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
      {
         provide: DateAdapter,
         useClass: CustomDateAdapter,
         deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
      },
      { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
      { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
      StageService,
      CodeService,
      TimeService,
      AppBasicService,
   ],
})
export class CoreModule {
   static forRoot(): ModuleWithProviders<any> {
      return {
         ngModule: CoreModule,
         providers: [AuthService],
      }
   }
}

